import { render } from "./PurchaseOrdersHistory.vue?vue&type=template&id=78fa754b"
import script from "./PurchaseOrdersHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__